module.exports = __webpack_public_path__ + "static/media/business smart final icon.b7ec67bf.svg";